import { linkedToTypes } from 'modules/documents/constants/linkedToTypes';
import { DocumentLinkedTo } from 'types';

type GetLinkedToProps = {
  partnerId?: string;
  operationId?: string;
  tradingOfferId?: string;
  tradingOfferOperationId?: string;
};

export const getLinkedTo = ({
  partnerId,
  operationId,
  tradingOfferId,
  tradingOfferOperationId,
}: GetLinkedToProps): DocumentLinkedTo[] => {
  const linkedTo: DocumentLinkedTo[] = [];

  if (partnerId) {
    linkedTo.push({
      linkedId: partnerId,
      linkedType: linkedToTypes.PARTNER,
    });
  }

  if (operationId) {
    linkedTo.push({
      linkedId: operationId,
      linkedType: linkedToTypes.OPERATION,
    });
  }

  if (tradingOfferId) {
    linkedTo.push({
      linkedId: tradingOfferId,
      linkedType: linkedToTypes.TRADING_OFFER,
    });
  }

  if (tradingOfferOperationId) {
    linkedTo.push({
      linkedId: tradingOfferOperationId,
      linkedType: linkedToTypes.TRADING_OFFER_OPERATION,
    });
  }

  return linkedTo;
};
